var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-intro',[_c('h2',{staticClass:"alpha"},[_vm._v("Prijsindicatie inzien?")]),_c('h3',[_vm._v("Laat dan uw e-mail adres achter")])]),_c('price-form',{attrs:{"theme":"light"},on:{"priceIndicationFormSent":_vm.closePriceIndicationModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }